import React, {Component} from "react";
import { connect } from "react-redux";
import {  Modal,ModalHeader,Button,ModalBody, ModalFooter, Row, Col } from "reactstrap";
import Proptypes from "prop-types";
import { logout } from "../../actions/actionLogin";

class Logout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            logoutAll: false,
        };
        this.toggle = this.toggle.bind(this);
        this.confirmLogout = this.confirmLogout.bind(this);
        this.cancelLogout = this.cancelLogout.bind(this);
        this.updateLogoutAll = this.updateLogoutAll.bind(this);
    }

    toggle(){
        this.props.onChange(!this.props.showLogout)
    }

    confirmLogout(){
        let logout_data = {logout_all: this.state.logoutAll};
        this.props.logout(logout_data);
        this.toggle();
    }

    cancelLogout(){
        this.toggle();
    }

    updateLogoutAll() {
        this.setState({logoutAll: !this.state.logoutAll});
    }

    componentDidMount(){
    }

    render() {
        return (
            <div>
                <Modal 
                    isOpen={this.props.showLogout} 
                    toggle={this.cancelLogout}
                    backdrop={true} 
                    centered={true}
                    className="user-modal confirm-modal"
                >
                    <ModalHeader toggle={this.cancelLogout}>
                        Are you sure you want to logout?
                    </ModalHeader>
                    <ModalBody className="confirm-modal-body">
                        <div className="opera-Productivity">
                            <span><input type="checkbox" value={this.state.logoutAll} onChange={this.updateLogoutAll}/> &nbsp; &nbsp;Sign out of all devices.</span>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.cancelLogout} className="cancel-button" size="sm" color="basic"> Cancel</Button>
                        <Button onClick={this.confirmLogout} className="delete-button"  size="sm" color="danger"> Logout</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

Logout.propTypes = {
    logout: Proptypes.func.isRequired,
};

function mapStateToProps(state) {
    return {

    };
}

function mapDispatchToProps(dispatch) {
    return({
        logout: (logout_data) => {dispatch(logout(logout_data));},
        getLoginSettings: () => {dispatch(getLoginSettings());},
    });
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Logout);

